import {
  Component, Input, Output, EventEmitter, OnInit
} from '@angular/core';

import { DropdownItem } from 'models/dropdown.model';
import { ButtonDropdownLayoutMod, SvgIconSizeMod } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-button-dropdown',
  templateUrl: './button-dropdown.component.html',
  styleUrls: ['./button-dropdown.component.scss']
})
export class ButtonDropdownComponent implements OnInit {
  @Input() buttonText = '';

  @Input() layoutMod: ButtonDropdownLayoutMod = 'form';

  @Input() items: DropdownItem[] = [];

  @Input() disabled = false;

  @Output() itemSelected: EventEmitter<DropdownItem> = new EventEmitter();

  isOpen = false;

  layoutModifier = '';

  icon: 'arrow' | 'actions' | '' = '';

  readonly svgIconSizeMod = SvgIconSizeMod;

  constructor(private stylingService: StylingService) { }

  ngOnInit(): void {
    if (this.layoutMod === 'form' || this.layoutMod === 'form_sm') {
      this.icon = 'arrow';
    } else if (this.layoutMod === 'table') {
      this.icon = 'actions';
    }

    this.layoutModifier = this.stylingService.concatLayoutModifiers('dropdownBtn', [this.layoutMod]);
  }

  toggleMenu(e: Event): void {
    e.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  onItemSelected(e: Event, item: DropdownItem): void {
    this.toggleMenu(e);
    this.itemSelected.emit(item);
  }

  onDropdownLeave(): void {
    this.isOpen = false;
  }
}
